import { Outlet, Navigate } from 'react-router-dom';
import { usePermissions } from '@/contexts/unified-permissions';
import { LoadingState } from '@/components/ui/loading-state';

export const AdminRoute = () => {
  const { isAdmin, permissionsStatus } = usePermissions();

  if (permissionsStatus === 'loading') {
    return (
      <LoadingState
        title="Checking admin permissions"
        description="Verifying your admin status..."
        size="md"
        fullScreen={true}
      />
    );
  }

  if (!isAdmin) {
    // Redirect to journal page instead of showing error
    return <Navigate to="/journal" replace />;
  }

  // If admin, render the child routes
  return <Outlet />;
};
